/**
 * HTML meta tags service manager
 */
app.service('htmlMetaService', [function () {

    var $ = window.jQuery || angular.element;

    /**
     * @param {String} key
     * @param {*} defaultValue
     * @returns {String|null}
     */
    this.get = function (key, defaultValue) {
        defaultValue = angular.isDefined(defaultValue) ? defaultValue : null;
        var $meta = this.getElement(key);
        if ($meta && $meta.length) {
            return $meta.attr('content');
        }
        return defaultValue;
    };

    /**
     * @param {String} key
     * @param {String} value
     * @returns {htmlMetaService}
     */
    this.set = function (key, value) {
        this.getElement(key).attr('content', value);
        return this;
    };

    /**
     * @param {String} key
     * @param {String} value
     * @returns {htmlMetaService}
     */
    this.add = function (key, value) {
        if (this.has(key)) {
            return this.set(key, value);
        }
        var $meta = $('meta').attr({
            'name': key,
            'content': value || ''
        });
        $('head').prepend($meta);
        return this;
    };

    /**
     * @param {String} key
     * @returns {htmlMetaService}
     */
    this.remove = function (key) {
        this.getElement(key).remove();
        return this;
    };

    /**
     * @param {String} key
     * @returns {boolean}
     */
    this.has = function (key) {
        var $meta = $('meta[name="' + key + '"]');
        return Boolean($meta && $meta.length);
    };

    /**
     *
     * @param {String} key
     * @returns {HTMLElement}
     * @throws {Error}
     */
    this.getElement = function (key) {
        if (this.has(key)) {
            return $('meta[name="' + key + '"]');
        }
        throw new Error('htmlMetaService :: Error - meta tag "' + key + '" does not exists');
    };

}]);